import Swiper from 'swiper'

const SWIPER_CONFIG = {
  history: {
    spaceBetween: 20,
    autoHeight: true,
    navigation: {
      nextEl: '.js-swiper-next',
      prevEl: '.js-swiper-prev',
    },
  },
  historyThumb: {
    spaceBetween: 0,
    slidesPerView: 7,
    freeMode: false,
    centeredSlides: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      // when window width is >= 320px
      240: {
        slidesPerView: 3,
      },
      760: {
        slidesPerView: 5,
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 7,
      },
    },
  },
}

export default class {
  constructor ($el, $thumbEl) {
    this.$el = $el
    this.$thumbEl = $thumbEl
  }

  init () {
    let thumbSlider = new Swiper(this.$thumbEl, SWIPER_CONFIG['historyThumb']);
    let historySlider = new Swiper(this.$el, SWIPER_CONFIG['history']);
    thumbSlider.controller.control = historySlider
    historySlider.controller.control = thumbSlider
    return historySlider
  }
}



// WEBPACK FOOTER //
// ./scripts/components/history-slider.js